jQuery(document).ready(function ($) {
		
		var spflag;
		if($('body').hasClass('is-sp')){
			spflag = true;
		}else{
			spflag = false;
		}
    console.log(spflag);
    var slidGroup = $('.campaign-slidr');
    var slidGroupNum = slidGroup.length;
    
    for(var s = 1; s <= slidGroupNum+1; s++ ){
	    $('.campaign-slidr-'+s).on('init', function () {
	      $('.slick-dots li:first-child svg').addClass('is-active');
	      $('.slick-current').addClass('is-active');
	    }).on('beforeChange', function () {
	      $('.slick-active svg').removeClass('is-active');
	      $('.slick-current').removeClass('is-active');
	    }).on('afterChange', function () {
	      $('.slick-active svg').addClass('is-active');
	      $('.slick-current').addClass('is-active');
	    });
		    
			$('.campaign-slidr-'+s).slick({
	      dots: true,
	      speed: 1000,
	      infinite: true,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      autoplay: false,
	      autoplaySpeed: 7000,
	      pauseOnFocus: false,
	      pauseOnHover: false,
	      pauseOnDotsHover: false,
	      adaptiveHeight:true,
	      customPaging: function (slider, i) {
	        return $('<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g><circle cx="7" cy="7" r="7" stroke="none"/><circle cx="7" cy="7" r="6"/></g></svg>');
	      },
	      prevArrow: '<div class="u-slide-arrow u-prev-arrow"><img src="data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkFycm93IEEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjI5IiB2aWV3Qm94PSIwIDAgMTYgMjkiPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSI3OW95ZTRzanlhIj4KICAgICAgICAgICAgPHBhdGggZGF0YS1uYW1lPSLplbfmlrnlvaIgMjQ3OCIgc3R5bGU9ImZpbGw6I2ZmZiIgZD0iTTAgMGgxNnYyOUgweiIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+CiAgICA8ZyBkYXRhLW5hbWU9IuODnuOCueOCr+OCsOODq+ODvOODlyAxNjEiIHN0eWxlPSJjbGlwLXBhdGg6dXJsKCM3OW95ZTRzanlhKSI+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSLliY3pnaLjgqrjg5bjgrjjgqfjgq/jg4jjgaflnovmipzjgY0gNCIgZD0iTTQ0Ni43MTYgMTkuNzE2aC0xLjQzMnYtMjBoMjB2MS40MzJoLTE4LjU2OHYxOC41Njd6IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMjQwLjA1NiA1NDQuNDM0KSIgc3R5bGU9ImZpbGw6I2ZmZiIvPgogICAgPC9nPgo8L3N2Zz4K"></div>',
	      nextArrow: '<div class="u-slide-arrow u-next-arrow"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDE2IDI5Ij4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iYTk4YTk2ZThpYSI+CiAgICAgICAgICAgIDxwYXRoIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI0NzgiIHN0eWxlPSJmaWxsOiNmZmYiIGQ9Ik0wIDBoMTZ2MjlIMHoiLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgogICAgPGcgZGF0YS1uYW1lPSJBcnJvdyBBIj4KICAgICAgICA8ZyBkYXRhLW5hbWU9IuODnuOCueOCr+OCsOODq+ODvOODlyAxNjEiIHN0eWxlPSJjbGlwLXBhdGg6dXJsKCNhOThhOTZlOGlhKSIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDggMTQuNSkiPgogICAgICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IuWJjemdouOCquODluOCuOOCp+OCr+ODiOOBp+Wei+aKnOOBjSA0IiBkPSJNNDQ2LjcxNiAxOS43MTZoLTEuNDMydi0yMGgyMHYxLjQzMmgtMTguNTY4djE4LjU2N3oiIHRyYW5zZm9ybT0icm90YXRlKC00NSAyNDAuMDU2IDU0NC40MzQpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"></div>'
					
				}).on('touchmove', function (event, slick, currentSlide, nextSlide) {
					$('.campaign-slidr-'+s).slick('slickPlay');
			});
			
		  function setKvImage () { // キービジュアルのサイズ変更 ＆ SP時にクリック範囲拡大
		    if ($('.campaign-slidr-'+s).find('.js-u-carousel-kv-single')[0]) {
		      var $slideSingle = $('.campaign-slidr-'+s).find('.js-u-carousel-kv-single');
		      $slideSingle.each(function () {
		        var imgAry = $(this).data('images');
		        console.log(imgAry);
		        var cssText = '';
		        if (spflag ) {
		          cssText = imgAry[1];
		        } else {
		          cssText = imgAry[0];
		        }
		        $(this).attr('style', 'background-image: url(' + cssText + ');');
		        if ($(this).find("a").length > 0) {
		          if (spflag) {
		            $(this).on('click', function () {
		              window.location = $(this).find('a').attr('href');
		            });
		          } else {
		            $(this).off('click');
		          }
		        } else {
		          $(this).off('click');
		          // return false;
		        }
		      });
		    }
		  }
			setKvImage();
    }
    setKvImage();

		$('.more-btn-pc').on('click',function(){
			$(this).toggleClass('closed');
			$(this).prev('div.content-wrap').toggleClass('unlimited');
			$(this).parents('.js-u-carousel-kv-single').toggleClass('filtered');
			if($(this).hasClass('closed')){
				$(this).text('× 閉じる');
			}else{
				$(this).text('＋ 続きを読む');
			}
		})
		
		
		
		
});
